import CriteriaVM from './criteria-vm'
import FieldVM from './field-vm'
import ResourceVM from './resource-vm'
import ConfigurationVM from './configuration-vm'

export default function (data, wizard) {
  this.wizard = wizard
  this.$el = $('#js-cw-submission')
  this.currentStep = ko.observable()
  this.$instCriteriaContainer = $('#js_inst_criteria_container')
  this.$peerCriteriaContainer = $('#js_peer_criteria_container')

  this.$galleryParticipationCriteriaContainer = $(
    '#js_gallery_participation_criteria_container'
  )

  this.$forumParticipationCriteriaContainer = $(
    '#js_forum_participation_criteria_container'
  )

  this.$resourceContainer = $('#js_resource_container')
  this.$criteriaBreakdown = $('#js-criteria-breakdown')
  this.coursework = ko.observable()
  this.coursework_listing = ko.observableArray([])
  this.savedAt = ko.observable()
  this.saving = ko.observable()

  this.dummyBool = ko.observable(true)
  //
  // TODO: used to force computed observable to update
  //

  this.maxAllowableGrade = ko.observable(100)
  this.criteriaBreakdown = ko.observableArray()
  this.showCriteriaBreakdown = ko.observable(false)
  this.showPublishButton = ko.observable(false)

  this.showPeerAssessmentDeadline = ko.computed(
    () => Kadenze.isKannu && this.coursework() && !this.coursework().is_adaptive()
  )

  this.newCriteria = ko.observable(false)
  this.newConfiguration = ko.observable(false)
  this.newField = ko.observable(false)
  this.newResource = ko.observable(false)
  this.stepCounter = 1

  this.defaultNoticeOptions = {
    method: 'append'
  }

  this.autograders = ko.mapping.fromJSON($('#autograders_json').val())
  this.criteria_cache = ko.observable({})
  this.grading_policies = ko.mapping.fromJSON($('#grading_policies_json').val())

  this.courseworkList = ko.mapping.fromJSON($('#coursework_json').val())
  this.gradePostTypeData = this.courseworkList.grade_post_type_data

  this.selectedGradingPolicy = ko.computed(() => {
    let name = ''

    if (this.coursework() && this.coursework().grading_policy_entry_id()) {
      const selected_policy = this.grading_policies().find(
        gp => gp.id() == this.coursework().grading_policy_entry_id()
      )

      if (selected_policy)
        name = selected_policy.name()
    }

    return name
  })

  this.gradePostingData = ko.computed(() => {
    let name = ''

    if (this.coursework() && this.coursework().grade_post_type_data()) {
      const selected_policy = this.gradePostTypeData().find(
        gp => gp.id() == this.coursework().grade_post_type()
      )

      if (selected_policy)
        name = selected_policy.name()
    }

    return name
  })

  const applicationsJSON = $('#external_applications_json').val()

  if (applicationsJSON)
    this.external_applications = ko.observableArray(
      JSON.parse(applicationsJSON).external_applications
    )

  this.initUI = () => {
    this.$launchFrame = $('#js-coursework-lti-launch-frame')

    $('.selectpicker').selectpicker('refresh')

    this.initGradeBreakdownChart()

    $(window).resize(() => this.refreshCharts())
  }

  this.initStepUI = id => {
    this.currentStep(id)
    this.showCriteriaBreakdown(false)

    if (id == 'js-cw-step2') {
      $('#courseworkSelectGallery').selectpicker('refresh')
      $('#courseworkSelectForum').selectpicker('refresh')

      if (this.hasCriteriaWithScope('instructor'))
        this.$instCriteriaContainer.collapse('show')

      if (this.hasCriteriaWithScope('peer'))
        this.$peerCriteriaContainer.collapse('show')

      if (this.hasCriteriaWithScope('gallery'))
        this.$galleryParticipationCriteriaContainer.collapse('show')

      if (this.hasCriteriaWithScope('forum'))
        this.$forumParticipationCriteriaContainer.collapse('show')

      this.showCriteriaBreakdown(true)
      this.initInstCriteriaSortable()
      this.initPeerCriteriaSortable()

      this.newCriteria.subscribe(() => {
        if (!this.newCriteria()) {
          this.initInstCriteriaSortable()
          this.initPeerCriteriaSortable()
        }
      })
    }

    if (id == 'js-cw-step3') {
      this.initAGCriteriaSortable()

      ko.computed(() => {
        this.newField()

        if (!this.newCriteria())
          setTimeout(this.initAGCriteriaSortable, 1000)
      })

      if (this.hasCriteriaWithScope('autograder'))
        this.showCriteriaBreakdown(true)
    }

    if (id == 'js-cw-step4') {
      this.initResourcesSortable()
      this.loadExistingResources()
    }

    if (id == 'js-cw-lti-launch-step')
      this.updateLaunchFrame()
  }

  this.initInstCriteriaSortable = () => {
    if (!this.coursework().id())
      return

    const url = Kadenze.Routes.sort_course_coursework_grading_criteria_path(
      this.coursework().course_id(),
      this.coursework().id()
    )

    const $el = this.$instCriteriaContainer.find(
      '.display-table.sortable .display-table__body'
    )

    Kadenze.UIUtil.initSortable(url, $el, this.$instCriteriaContainer, this.sort)
  }

  this.initAGCriteriaSortable = () => {
    if (!this.coursework().id())
      return

    const fields = this.newField() ?
      [this.newField()] :
      this.coursework().coursework_fields()

    fields.forEach(field => {
      const url = Kadenze.Routes.sort_course_coursework_grading_criteria_path(
        this.coursework().course_id(),
        this.coursework().id()
      )

      const $agFieldCriteriaContainer = $('#' + field.dom_id() + '-agc-listing')

      const $el = $agFieldCriteriaContainer.find(
        '.display-table.sortable .display-table__body'
      )

      Kadenze.UIUtil.initSortable(url, $el, $agFieldCriteriaContainer, this.sort)
    })
  }

  this.initPeerCriteriaSortable = () => {
    if (!this.coursework().id())
      return

    const url = Kadenze.Routes.sort_course_coursework_grading_criteria_path(
      this.coursework().course_id(),
      this.coursework().id()
    )

    const $el = this.$peerCriteriaContainer.find(
      '.display-table.sortable .display-table__body'
    )

    Kadenze.UIUtil.initSortable(url, $el, this.$peerCriteriaContainer, this.sort)
  }

  this.initResourcesSortable = () => {
    if (!this.coursework().id())
      return

    const url = Kadenze.Routes.sort_course_coursework_resources_path(
      this.coursework().course_id(),
      this.coursework().id()
    )

    const $el = this.$resourceContainer.find(
      '.display-table.sortable .display-table__body'
    )

    Kadenze.UIUtil.initSortable(url, $el, this.$resourceContainer, this.sort)
  }

  this.refreshCharts = () => {
    if (this.criteriaBreakdownChart)
      this.criteriaBreakdownChart.refresh()
  }

  this.initGradeBreakdownChart = () => {
    this.coursework().weight.subscribeChanged((newValue, oldValue) => {
      const percentRegEx = /\d+(?:\.\d+)?%/g

      const difference = newValue - (oldValue || newValue)

      const currentGrade = this.coursework().grade_breakdown().find(
        grade => grade.type() == 'current'
      )

      currentGrade.percent(newValue)

      currentGrade.title(
        currentGrade.title().replace(
          percentRegEx,
          currentGrade.percent.extend({ numberToPercentage: 2 })()
        )
      )

      const unusedGrade = this.coursework().grade_breakdown().find(
        grade => grade.type() == 'unused'
      )

      const used = this.coursework().grade_breakdown().reduce(
        (memo, value) => memo + parseFloat(value.percent()), 0
      )

      unusedGrade.percent(Math.max(0, (100 - used)))

      unusedGrade.title(
        unusedGrade.title().replace(
          percentRegEx,
          unusedGrade.percent.extend({ numberToPercentage: 2 })()
        )
      )

      const otherCW = _.filter(this.coursework().grade_breakdown(), g => g.type() == '')
      const otherCWTotal = _.reduce(otherCW, (memo, value) => memo + value.percent(), 0)
      const max = Math.max(0, (100 - otherCWTotal))

      this.maxAllowableGrade(max)
    })
  }

  this.validateForumCreation = (item, event) => {
    const forumParticipationCriteria = this.forumParticipationCriteria() || (
      this.newCriteria() && this.newCriteria().scope() === 'forum' ?
          this.newCriteria() : null
    )

    if (
      this.coursework().forum_settings.enabled() &&
        forumParticipationCriteria &&
          forumParticipationCriteria.entry_requirements().global &&
            forumParticipationCriteria.entry_requirements().global.coursework_id &&
              forumParticipationCriteria.entry_requirements().global.coursework_id() === this.coursework().id()
    ) {
      new Kadenze.Notice.error(
        Object.assign({}, this.defaultNoticeOptions, { message: 'You have selected to accept participation from this forum, please select a different forum before turning this off.' })
      )

      return false
    } else {
      return true
    }
  }

  this.canRemoveGalleryField = () => {
    const galleryParticipationCriteria = this.galleryParticipationCriteria() || (
      this.newCriteria() && this.newCriteria().scope() === 'gallery' ?
        this.newCriteria() : null
    )

    const galleryFieldCount = this.coursework().coursework_fields().map(
      field => field.gallery()
    ).length

    return !(
      galleryFieldCount <= 1 &&
        galleryParticipationCriteria &&
          galleryParticipationCriteria.entry_requirements().global &&
            galleryParticipationCriteria.entry_requirements().global.coursework_id &&
              galleryParticipationCriteria.entry_requirements().global.coursework_id() === this.coursework().id()
    )
  }

  this.allCriteria = ko.computed(() => {
    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    const fields = this.coursework() ?
      this.coursework().coursework_fields() : []

    return criteria.concat(fields.flatMap(f => f.grading_criteria()))
  })

  this.totalCriteriaWeight = ko.computed(() => {
    return this.allCriteria().map(criterion => (
        criterion.extra_credit() ||
          criterion._destroy() ||
            !criterion.numerical_assessment_required()
      ) ? 0 : parseFloat(criterion.weight())
    ).reduce((memo, num) => memo + num, 0)
  })

  this.extraCreditCriteriaWeight = ko.computed(() => {
    return this.allCriteria().map(criterion => (
        !criterion.extra_credit() ||
          criterion._destroy() ||
            !criterion.numerical_assessment_required()
      ) ? 0 : parseFloat(criterion.weight())
    ).reduce((memo, num) => memo + num, 0)
  })

  this.criteriaBreakdownWatcher = ko.computed(() => {
    if (this.showCriteriaBreakdown()) {
      const colors = {
        instructor: '#00BA95',
        peer: '#6A70A4',
        assessment: '#73BFFF',
        autograder: '#CC5F58',
        gallery: '#59D8E6',
        forum: '#FFB200',
        completion: '#8E130E'
      }

      const criteria = this.allCriteria()

      const predicate = criterion => (
        criterion.extra_credit() ||
          criterion._destroy() ||
            !criterion.numerical_assessment_required()
      ) ? null : {
        label: criterion.name(),
        percent: parseFloat(criterion.weight()),
        color: colors[criterion.scope()],
        href: '#'
      }

      const breakdown =  _.sortBy(_.compact(_.map(criteria, predicate)), 'color')

      const total_weight = this.totalCriteriaWeight()

      if (total_weight < 100)
        breakdown.push({
          label: 'Unassigned',
          percent: 100 - total_weight,
          color: '#D1D1D1',
          href: '#'
        })

      this.criteriaBreakdown(breakdown)
      this.initCriteriaBreakdownChart()
    }
  })

  this.completionCriteria = ko.computed(() => {
    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    return criteria.find(
      criterion => !criterion._destroy() && criterion.scope() == 'completion'
    )
  })

  this.assessmentCriteria = ko.computed(() => {
    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    return criteria.find(
      criterion => !criterion._destroy() && criterion.scope() == 'assessment'
    )
  })

  this.assessmentCriteria.subscribe(criterion => {
    if (!criterion.length && this.$peerCriteriaContainer.hasClass('in'))
      this.$peerCriteriaContainer.collapse('hide')
  })

  this.galleryParticipationCriteria = ko.computed(() => {
    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    return criteria.find(
      criterion => !criterion._destroy() && criterion.scope() == 'gallery'
    )
  })

  this.galleryParticipationCriteria.subscribe(criterion => {
    if (!criterion.length && this.$galleryParticipationCriteriaContainer.hasClass('in'))
      this.$galleryParticipationCriteriaContainer.collapse('hide')
  })

  this.forumParticipationCriteria = ko.computed(() => {
    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    return criteria.find(
      criterion => !criterion._destroy() && criterion.scope() == 'forum'
    )
  })

  this.forumParticipationCriteria.subscribe(criterion => {
    if (_.isEmpty(criterion) && this.$forumParticipationCriteriaContainer.hasClass('in')) {
      this.$forumParticipationCriteriaContainer.collapse('hide')
    }
  })

  this.initCriteriaBreakdownChart = () => {
    const data = ko.toJS(this.criteriaBreakdown())
    const total = this.totalCriteriaWeight.extend({ numberToPercentage: 2 })

    this.$criteriaBreakdown.html('')

    this.criteriaBreakdownChart = new Kadenze.Chart.RingChart(
      '#js-criteria-breakdown',
      data,
      total(),
      'OF TOTAL'
    )

    this.criteriaBreakdownChart.refresh()
  }

  this.addCriteria = (scope, field) => {
    if (
      scope != 'instructor' &&
        !this.hasCriteriaWithScope('instructor') && this.$instCriteriaContainer.hasClass('in')
    )
      this.$instCriteriaContainer.collapse('hide')

    if (
      scope != 'peer' &&
        !this.hasCriteriaWithScope('peer') &&
          this.$peerCriteriaContainer.hasClass('in')
    )
      this.$peerCriteriaContainer.collapse('hide')

    if (
      scope != 'gallery' &&
        !this.hasCriteriaWithScope('gallery') &&
          this.$galleryParticipationCriteriaContainer.hasClass('in')
    )
      this.$galleryParticipationCriteriaContainer.collapse('hide')

    if (
      scope != 'forum' &&
        !this.hasCriteriaWithScope('forum') &&
          this.$forumParticipationCriteriaContainer.hasClass('in')
    )
      this.$forumParticipationCriteriaContainer.collapse('hide')

    const criteria = new CriteriaVM(
      { scope: scope, editing: true, _destroy: false }, this, field
    )

    this.newCriteria(criteria)
  }

  this.addConfiguration = field => {
    const configuration = new ConfigurationVM(
      { editing: true, _destroy: false }, this, field
    )

    this.newConfiguration(configuration)
  }

  this.hasCriteriaWithScope = scope => {
    return ko.computed(() => {
      const criteria = this.allCriteria()

      return _.some(
        criteria,
        criterion => criterion._destroy() ? false : criterion.scope() == scope
      )
    })()
  }

  this.activateCompletionAssessment = () => {
    if (!this.hasCriteriaWithScope('completion'))
      this.addCriteria('completion')
  }

  this.activateInstructorAssessment = (item, event) => true

  this.activatePeerAssessment = (item, event) => {
    if (!this.hasCriteriaWithScope('assessment'))
      this.addCriteria('assessment')
  }

  this.activateGalleryParticipationAssessment = (item, event) => {
    if (!this.hasCriteriaWithScope('gallery'))
      this.saveCourseworkDeferred().done(() => this.addCriteria('gallery'))
  }

  this.activateForumParticipationAssessment = (item, event) => {
    if (!this.hasCriteriaWithScope('forum'))
      this.saveCourseworkDeferred().done(() => this.addCriteria('forum'))
  }

  this.coursework_shareable_families = ko.computed(() => {
    const list = ko.utils.arrayMap(this.coursework_listing(), cw => {
      if (cw['has_shareable_fields?']())
        return cw['adaptive?']() ? cw.session_name() : cw.family_name()
    })

    return ko.utils.arrayGetDistinctValues(list)
  })

  this.coursework_listing_families = ko.computed(() => {
    const list = ko.utils.arrayMap(this.coursework_listing(), cw => {
      return cw['adaptive?']() ? cw.session_name() : cw.family_name()
    })

    return ko.utils.arrayGetDistinctValues(list)
  })

  this.loadGraderInfoForField = _.memoize(
    field => {
      const getDetails = (graderId, graderVersion) => {
        const req = new Kadenze.AjaxRequest({
          type: 'GET',
          url: Kadenze.Routes.describe_autograder_path(graderId, { version: graderVersion }),
          timeout: 30000
        })

        req.done(response => {
          if (typeof response.errors != 'undefined') {
            console.warn('Error fetching criteria:')
            console.warn(response.errors)
          } else {
            field.auto_grader_details(response)
            field.auto_grader_jsonapi_version(response['json_api_version'])

            const cache = this.criteria_cache()

            cache[graderId] = response

            this.criteria_cache(cache)
          }
        })

        req.fail(response => { })

        return 1
      }

      if (field.auto_grader_id() && field.auto_grader_version())
        getDetails(field.auto_grader_id(), field.auto_grader_version())

    },
    input => input.auto_grader_id() + input.auto_grader_version()
  )

  this.addField = () => {
    if (!this.coursework().submissions_begun())
      this.newField(new FieldVM({ editing: true, _destroy: false }, this))
  }

  this.addResource = () => {
    const data = ko.mapping.toJS(this.coursework().resource_template)

    const resource = new ResourceVM(
      Object.assign({}, data, { editing: false, _destroy: false }), this
    )

    this.newResource(resource)
    this.newResource().resource().updated_at(new Date())
  }

  this.getFriendlyCSV = (array, conjunction) => {
    const csv = _.compact(array).join(', ')
    const last_comma = csv.lastIndexOf(',')

    return csv.slice(0, last_comma) +
      csv
        .slice(last_comma)
        .replace(',', (' ' + conjunction + ' '))
  }

  this.criteriaNamesByScope = scope => {
    return ko.computed(() => {
      const criteria = this.coursework() ? this.coursework().grading_criteria() : []

      const predicate = criterion => (
        !criterion._destroy() &&
          criterion.scope() == scope
      ) ? criterion.name() : null

      return this.getFriendlyCSV(criteria.map(predicate), 'and')
    })()
  }

  this.associatedLectures = ko.computed(() => {
    const lectures = this.coursework() ?
      this.coursework().lectures() : []

    const predicate = lecture => {
      return (
        this.coursework().lecture_ids().indexOf(lecture.id()) > -1
      ) ? lecture.title_with_type_and_number() : null
    }

    return this.getFriendlyCSV(lectures.map(predicate), 'and')
  })

  this.savedAtText = ko.computed(() => {
    this.dummyBool()

    if (this.saving()) {
      //
      // TODO: no-op?
      //
    } else if (this.savedAt()) {
      return I18n.t('dict.last_saved_at') + ' ' + moment(this.savedAt()).fromNow()
    } else {
      return ''
    }
  })

  this.validate = deep => {
    let errors = []

    this.client_errors = ko.validation.group(this.coursework(), { deep: deep })
    this.client_errors.showAllMessages()

    errors = this.client_errors()

    if (this.coursework() && deep) {
      const isValid = item => errors = errors.concat(item.validate())

      this.coursework().coursework_fields().forEach(isValid)
      this.coursework().grading_criteria().forEach(isValid)
      this.coursework().resources().forEach(isValid)
    }

    return errors
  }

  this.saveCourseworkDeferred = () => {
    const deferred = $.Deferred()

    if (this.coursework().id()) {
      deferred.resolve()
    } else {
      const response = this.save(this.$el)

      response.success(() => deferred.resolve())

      response.error((xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error(
          Object.assign(
            {},
            this.defaultNoticeOptions,
            { message: xhr.responseJSON.errors }
          )
        )
      })
    }

    return deferred
  }

  this.saveCoursework = (item, element) => {
    const save = () => {
      const $container = this.$el

      const response = this.save($container)

      response.error((xhr, textStatus, errorThrown) => {
        new Kadenze.Notice.error(
          Object.assign(
            {},
            this.defaultNoticeOptions,
            { message: xhr.responseJSON.errors }
          )
        )
      })
    }

    const isInvalid = !!this.validate(true).length

    if (isInvalid) {
      Kadenze.UIUtil.confirmAction(
        I18n.t('form_builder.invalid_save_confirmation')
          .supplant({ form_type: this.coursework().presentation_name() }),
        save
      )
    } else {
      save()
    }
  }

  this.previewCoursework = (item, element) => {
    const $container = this.$el
    const response = this.save($container)

    response.success(() => {
      window.location = Kadenze.Routes.course_coursework_path(
        this.coursework().course_id(),
        this.coursework().slug(),
        { preview: true, exit_path: encodeURI(window.location.pathname) }
      )
    })

    response.error((xhr, textStatus, errorThrown) => {
      new Kadenze.Notice.error(
        Object.assign({}, this.defaultNoticeOptions, { message: xhr.responseJSON.errors })
      )
    })
  }

  this.publishCoursework = (item, element) => {
    const $container = this.$el
    const method = 'PATCH'

    if (this.publishError)
      this.publishError.destroy()

    const response = this.save($container, true)

    response.success(() => {
      const url = Kadenze.Routes.publish_course_coursework_path(
        this.coursework().course_id(),
        this.coursework().id()
      )

      const request = Kadenze.UIUtil.makeRequest(
        url,
        method,
        null,
        $container,

        (xhr, settings) => this.saving(true), // BeforeSave

        (data, textStatus, xhr) => { // Success
          this.savedAt(new Date())
          this.bindData(data.coursework)

          new Kadenze.Notice.success(
            Object.assign(
              {}, this.defaultNoticeOptions, { message: I18n.t('dict.publish_success') }
            )
          )
        },

        (xhr, textStatus, errorThrown) => { // Error
          this.publishError = new Kadenze.Notice.error(
            Object.assign(
              {
                title: `Please address ${xhr.responseJSON.errors.length > 1 ? 'these errors' : 'this error'} before publishing:`,
                persistent: true
              },
              this.defaultNoticeOptions,
              { message: xhr.responseJSON.errors }
            )
          )
        },

        (xhr, textStatus) => this.saving(false) // Complete
      )
    })

    response.error((xhr, textStatus, errorThrown) => {
      new Kadenze.Notice.error(
        Object.assign({}, this.defaultNoticeOptions, { message: xhr.responseJSON.errors })
      )
    })
  }

  this.unpublishCoursework = (item, element) => {
    const unpublish = () => {
      Kadenze.UIUtil.makeRequest(
        Kadenze.Routes.unpublish_course_coursework_path(
          this.coursework().course_id(),
          this.coursework().id()
        ),
        'PATCH',
        null,
        this.$el,

        (xhr, settings) => this.saving(true), // BeforeSave

        (data, textStatus, xhr) => { // Success
          this.savedAt(new Date())
          this.bindData(data.coursework)

          new Kadenze.Notice.success(
            Object.assign({}, this.defaultNoticeOptions, { message: I18n.t('dict.unpublish_success') })
          )
        },

        (xhr, textStatus, errorThrown) => { // Error
          new Kadenze.Notice.error(
            Object.assign({}, this.defaultNoticeOptions, { message: xhr.responseJSON.errors })
          )
        },

        (xhr, textStatus) => this.saving(false) // Complete
      )
    }

    const confirmAction = moment(
      this.coursework().start_date_string()
    ).isBefore(moment()) || this.coursework().entries_count() > 0

    if (confirmAction) {
      Kadenze.UIUtil.confirmAction(
        I18n.t('form_builder.unpublish_confirmation')
          .supplant({ form_type: this.coursework().presentation_name() }),
        unpublish
      )
    } else {
      unpublish()
    }
  }

  this.deleteCoursework = (item, element) => {
    Kadenze.UIUtil.confirmAction(
      I18n.t('coursework.delete.confirm'),
      () => {
        const $container = this.$el

        const redirectUrl = Kadenze.Routes.course_coursework_index_path(
          this.coursework().course_id()
        )

        const method = 'DELETE'

        if (!this.coursework().id()) {
          Kadenze.Request.pjax({
            url: redirectUrl,
            container: '#main-pjax-container',
          })

          return
        }

        const url = Kadenze.Routes.course_coursework_path(
          this.coursework().course_id(),
          this.coursework().id()
        )

        Kadenze.UIUtil.makeRequest(
          url,
          method,
          null,
          $container,

          (xhr, settings) => this.saving(true), // BeforeSave

          (data, textStatus, xhr) => { //Success
            new Kadenze.Notice.success(
              Object.assign(
                { dismissible: false },
                this.defaultNoticeOptions,
                { message: I18n.t('coursework.delete.success') }
              )
            )

            Kadenze.Request.pjax({
              url: redirectUrl,
              container: '#main-pjax-container'
            })
          },

          (xhr, textStatus, errorThrown) => { // Error
            new Kadenze.Notice.error(
              Object.assign({}, this.defaultNoticeOptions, { message: xhr.responseJSON.errors })
            )
          },

          (xhr, textStatus) => this.saving(false) // Complete
        )
      }
    )
  }

  //
  // Searches through this.existing_resources, if any have been selected
  // merge with this.resource_ids to create any new associations
  //
  this.attachExistingResources = () => {
    if(this.existing_resources && this.existing_resources().length) {
      const existingResourceIds = _.chain(this.existing_resources())
        .select(res => res.selected)
        .map(res => res.id)
        .value()

      this.coursework().resource_ids(
        _.union(this.coursework().resource_ids(), existingResourceIds)
      )
    }
  }

  this.save = ($container, isAutoSave) => {
    this.saving(true)

    let url = Kadenze.Routes.course_coursework_index_path(
      this.coursework().course_id()
    )

    let method = 'POST'

    if (this.coursework().id()) {
      url = Kadenze.Routes.course_coursework_path(
        this.coursework().course_id(),
        this.coursework().id()
      )

      method = 'PATCH'
    }

    this.attachExistingResources()

    const mapping = {
      include: ['coursework_fields', 'grading_criteria', 'grading_configurations'],
      ignore: ['resources', 'existing_resources']
    }

    if (
      [
        'LinkAssignment',
        'GenericAssignment',
        'ParticipationAssignment',
      ].includes(this.coursework().type())
    )
      mapping.ignore.push('file_types')

    //
    // ignore field ref in grading critiera to avoid recursive nesting issue
    //
    mapping.ignore.push('field_ref')
    mapping.ignore.push('parent')

    const data = {
      coursework: JSON.parse(ko.mapping.toJSON(this.coursework, mapping))
    }

    data.coursework.coursework_fields.forEach(item => {
      item.field_definition_attributes = item.field_definition
      item.grading_criteria_attributes = item.grading_criteria
      item.grading_configurations_attributes = item.grading_configurations

      delete(item.field_definition)
      delete(item.grading_criteria)
      delete(item.grading_configurations)
    })

    data.coursework.coursework_fields_attributes = data.coursework.coursework_fields
    data.coursework.grading_criteria_attributes = data.coursework.grading_criteria

    delete(data.coursework.coursework_fields)
    delete(data.coursework.grading_criteria)

    data.coursework.resources_attributes = this.coursework().resources().map(item => {
      const resource = ko.mapping.toJS(item.resource, { ignore: ['order'] })

      resource['info'] = ko.mapping.toJS(
        ko.mapping.fromJS(item.resource().info),
        { ignore: ['__ko_mapping__'] }
      )

      return resource
    })

    //
    // convert dates to utc
    //
    new Array(
      'start_date_string',
      'end_date_string',
      'due_date_string',
      'visible_on_string',
      'assessment_deadline_string',
    ).forEach(date_field => {
      if (data.coursework[date_field]) {

        data.coursework[date_field] = Kadenze.Util.getMomentDateFromObservable(
          this.coursework()[date_field]
        ).utc()
         .format(I18n.t('date.formats.js_default_with_zone'))

        delete(data.coursework[date_field.replace('_string','')])

      }
    })

    if (_.isArray(data.coursework.grading_criteria_attributes)) {
      data.coursework.grading_criteria_attributes.forEach(crit => {
        if (
          crit.entry_requirements &&
            crit.entry_requirements.commenting &&
              crit.entry_requirements.commenting.deadline
        )
          crit.entry_requirements.commenting.deadline = moment.utc(
            new Date(
              crit.entry_requirements.commenting.deadline.replace(/\s\w{3,4}$/, '')
            )
          ).format(I18n.t('date.formats.js_default_with_zone'))
      })
    }

    //
    // Delay the text showing again, so it and a success notification don't
    // show at the same time.
    //
    const onNoticeDismiss = () => setTimeout(() => this.savedAt(new Date()), 1000)

    return Kadenze.UIUtil.makeRequest(
      url,
      method,
      data,
      $container,

      (xhr, settings) => this.saving(true), // BeforeSave

      (data, textStatus, xhr) => { // Success
        this.bindData(data.coursework, isAutoSave)

        if (isAutoSave)
          this.savedAt(new Date())

        if (!isAutoSave) {
          //
          // Show the saved related text once this notice fades out (KADWEB-2054)
          //
          new Kadenze.Notice.success(
            Object.assign(
              {},
              this.defaultNoticeOptions,
              { message: I18n.t('dict.save_success'), onDismiss: onNoticeDismiss }
            )
          )
        }
      },

      (xhr, textStatus, errorThrown) => { }, // Error

      (xhr, textStatus) => this.saving(false) // Complete
    )
  }

  this.sort = (url, $el, $container) => {
    $.ajax({
      url: url,
      type: 'POST',
      data: $el.sortable('serialize'),

      beforeSend: (xhr, settings) => {
        this.saving(true)
        Kadenze.UIUtil.showLoadingIndicator($container)
      },

      success: (data, textStatus, xhr) => { },

      error: (xhr, textStatus, errorThrown) => {
        $el.sortable('cancel')
        new Kadenze.Notice.error(
          Object.assign(
            {},
            this.defaultNoticeOptions,
            { message: 'An unexpected error occurred. Please try again later.' }
          )
        )
      },

      complete: (xhr, textStatus) => {
        this.saving(false)
        Kadenze.UIUtil.hideLoadingIndicator($container)
      }
    })
  }

  this.editing = () => {
    const fields = this.coursework() ?
      this.coursework().coursework_fields() : []

    const criteria = this.coursework() ?
      this.coursework().grading_criteria() : []

    const configuration = this.coursework() &&
        this.coursework().grading_configurations ?
      this.coursework().grading_configurations() : []

    const resources = this.coursework() ?
      this.coursework().resources() : []

    const isEditing = item => item.editing()

    return this.newField() ||
      this.newConfiguration() ||
        this.newCriteria() ||
          this.newResource() ||
            _.some(fields, isEditing) ||
              _.some(configuration, isEditing) ||
                _.some(criteria, isEditing) ||
                  _.some(resources, isEditing)
  }

  this.bindData = (data, isAutoSave) => {
    if (typeof data === "string")
      data = JSON.parse(data)

    if (isAutoSave && this.editing()) {
      //
      // Only update the IDs to avoid interrupting the user
      //
      const mapped_coursework = ko.mapping.fromJS(data)
      this.coursework().id(mapped_coursework.id())
    } else {
      //
      // Bind the entire VM
      //
      const mapping = {
        coursework_fields: {
          create: options => new FieldVM(
            Object.assign({}, options.data, { editing: false, _destroy: false }),
            this
          )
        },

        grading_criteria: {
          create: options => new CriteriaVM(
            Object.assign({}, options.data, { editing: false, _destroy: false }),
            this
          )
        },

        resources: {
          create: options => new ResourceVM(
            Object.assign({}, options.data, { editing: false, _destroy: false }),
            this
          )
        },

        forum_settings: {
          update: options => {
            const vm = ko.mapping.fromJS(options.data)

            vm.name.extend({ notify: 'always' })

            vm.computed_name = ko.computed({
              read: () => vm.name() ||
                `${options.parent.number()}: ${options.parent.name() || '[Title]'}`,

              write: value => vm.name(value)
            }).extend({ notify: 'always' })

            vm.enabled.subscribe(() => this.save(this.$el))

            return vm
          }
        }
      }

      this.coursework(ko.mapping.fromJS(data, mapping))

      //
      // Hack to prevent select picker from validating on page load
      //
      if (this.coursework().grading_policy_entry_id() == null)
        this.coursework().grading_policy_entry_id(undefined)

      this.coursework().grading_policy_entry_id.subscribe(() => {
        if (isNaN(parseInt(this.coursework().grading_policy_entry_id())))
          return

        const url = Kadenze.Routes.grading_policy_breakdown_course_coursework_index_path(
          this.coursework().course_id(),
          {
            coursework_id: this.coursework().id(),
            grading_policy_entry_id: this.coursework().grading_policy_entry_id()
          }
        )

        const request = new Kadenze.AjaxRequest({
          type: 'GET',
          url: url,
          data: null,
          timeout: 60000
        })

        request.done((response, status, xhr) => {
          const mapped_breakdown = ko.mapping.fromJS(response.breakdown)
          this.coursework().grade_breakdown(mapped_breakdown())
          this.coursework().weight.valueHasMutated()
        })

        request.fail((xhr, status, msg) => { })
      })

      this.coursework().start_date_string(this.coursework().start_date())
      this.coursework().end_date_string(this.coursework().end_date())
      this.coursework().due_date_string(this.coursework().due_date())
      this.coursework().visible_on_string(this.coursework().visible_on())
      this.coursework().assessment_deadline_string(this.coursework().assessment_deadline())

      const mapped_listing = ko.mapping.fromJSON(
        this.coursework().course.coursework_listing_json()
      )

      this.coursework_listing(mapped_listing())
    }

    if (this.client_errors)
      this.client_errors.showAllMessages(false)

    $(document).off('pjax:start').on('pjax:start', evt => $('.notice').remove())
  }

  this.updateSavedTime = () => this.dummyBool(!this.dummyBool())

  this.filterOutById = (ids, items) => {
    return items.filter(item => !_.contains(ids, item.id))
  }

  this.isSubmittable = () => ![
      'GenericAssignment',
      'ParticipationAssignment',
      'ExternalAssignment',
    ].includes(this.coursework().type())

  this.isCompletionBased = ko.computed({
    read: () => (
      (
        this.newCriteria() &&
          this.newCriteria().scope() == 'completion'
      ) ||
      this.hasCriteriaWithScope('completion')
    ),

    write: value => {
      if (value) { // Add completion based criterion if checked
        if (!this.hasCriteriaWithScope('completion')) {
          this.activateCompletionAssessment()
          this.newCriteria().add(this.newCriteria())
        }
      } else { // Remove completion based criterion if unchecked
        const criteria = (
          this.newCriteria() &&
            this.newCriteria().scope() == 'completion'
        ) ? this.newCriteria : this.completionCriteria

        criteria().destroy()
      }
    }
  }).extend({ notify: 'always' })

  this.loadExistingResources = () => {
    const request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.course_resources_path(this.coursework().course_id())
    })

    request.done(response => {
      // Filter out already attached existing resources so they're
      // not displayed in the 'available to attach' list
      const resources = this.filterOutById(this.coursework().resource_ids(), response.resources)

      // Dynamically added property to track what resources are selected,
      // the KO bindings need this
      resources.forEach(resource => resource.selected = false)

      // So existing_resources are available from $parent in _resource_form_content.html.haml
      this.existing_resources = ko.observableArray(resources)
    })
  }

  this.launchExternalCoursework = () => {
    this.save(this.$el).success(() => {
      window.open(
        Kadenze.Routes.lti_frame_course_coursework_path(
          this.coursework().course_id(),
          this.coursework().id()
        ),
        '_blank'
      )
    })
  }

  this.updateLaunchFrame = () => {
    if (this.coursework().external_application_id()) {
      this.save(null).success(() => {
        Kadenze.Ajax.get({
          routeName: 'lti_iframe_course_coursework',
          routeParams: [this.coursework().course_id(), this.coursework().id()],
          dataType: 'html',
          loadingContainer: this.$el,

          done: html => {
            this.$launchFrame.html(html)
            $('#lti_frame_form').submit()
          }
        })
      })
    } else {
      this.$launchFrame.html('')
    }
  }

  (() => {
    this.bindData(data)

    Kadenze.Timers.push(setInterval(this.updateSavedTime, 1000))

    // Autosave
    const interval = setInterval(() => {
      const updated = this.savedAt()
      const diff = moment().diff(updated, 'minutes')

      // Make sure no other save, publish, delete actions are in progress
      if (diff > 5 && !this.saving())
        this.save(null, true)
        // Not passing any container, setting isAutoSave to true

    }, 60000)

    Kadenze.Timers.push(interval)
  })()
}
